import { render, staticRenderFns } from "./handle.vue?vue&type=template&id=619c9807&scoped=true&"
import script from "./handle.vue?vue&type=script&lang=js&"
export * from "./handle.vue?vue&type=script&lang=js&"
import style0 from "./handle.vue?vue&type=style&index=0&id=619c9807&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619c9807",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/mychefkoo/Documents/cloud-dom/cloud-web/erp-flexible-web21/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('619c9807')) {
      api.createRecord('619c9807', component.options)
    } else {
      api.reload('619c9807', component.options)
    }
    module.hot.accept("./handle.vue?vue&type=template&id=619c9807&scoped=true&", function () {
      api.rerender('619c9807', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Table/com/handle.vue"
export default component.exports